import { TPaymentStatus, TPaymentsCallbackStatus, TPaymentsStats } from '../../store/types';

export const paymentStatusList: TPaymentStatus[] = [
  'pending',
  'awaiting_approval',
  'awaiting_provider',
  'approved',
  'declined',
  'approved_delay',
  'approved_wrong_amount',
  'approved_manual',
];

export const paymentStatusTitles: Record<TPaymentStatus, string> = {
  pending: 'В ожидании',
  awaiting_approval: 'Ожидает подтверждения',
  awaiting_provider: 'Клиенту зачислено, ожидается подтверждение провайдера',
  approved: 'Одобрено',
  declined: 'Отклонено',
  approved_delay: 'Одобрено (задержка)',
  approved_wrong_amount: 'Одобрено (неверная сумма)',
  approved_manual: 'Одобрено (вручную)',
};

export const avalableApproveStatuses: TPaymentStatus[] = [
  'approved_delay',
  'approved_wrong_amount',
  'awaiting_approval',
];

export const avalableDeclineStatuses: TPaymentStatus[] = [
  'approved_delay',
  'approved_wrong_amount',
  'awaiting_approval',
];

export const availableApproveCustomStatuses: TPaymentStatus[] = [
  'approved_delay',
  'approved_wrong_amount',
  'awaiting_approval',
  'pending',
  'declined',
]

export const paymentCallbackStatusList: TPaymentsCallbackStatus[] = [
  'not_sent',
  'success',
  'failed',
];

export const paymentCallbackStatusTitles: Record<TPaymentsCallbackStatus, string> = {
  not_sent: 'Не отправлен',
  success: 'Успех',
  failed: 'Ошибка',
};

export const remoteCallbackStatusTitles: Record<string, string> = {
  COMPLETED: 'Успех',
  success: 'Успех',
  DECLINED: 'Отклонён',
  failed: 'Отклонён',
  CANCELLED: 'Отменён',
};

export const paymentsStatsTitles: Record<keyof TPaymentsStats, string> = {
  totalRequests: 'Общее кол-во заявок',
  totalApproved: 'Кол-во подтверждённых заявок',
};
